<template>
  <div class="SelectManager" >
    <div class="modal-header"> 
      <div class="closeButton">
        <button class="btn theme-close-button" @click="$emit('cancel')">
          <font-awesome-icon icon="times" />
        </button>
      </div>
      <div class="entity-title">{{ $t('tournament.selectManager.header') }}</div>
    </div>
    <div class="fieldsContainer">
      <div class="inputFields">
        <label>{{ $t('selectUser.filterClub') }}</label>
        <Multiselect
          v-model="selectedClub"
          placeholder="selecteer een club"
          label="name" 
          valueProp="clubId"
          trackBy="name"
          @search-change="loadClubs"
          :options="clubs"
          :filterResults="false"
          :searchable="true"
        />

        <label>{{ $t('selectUser.player') }}</label>
        <input type="text" v-model.lazy="personSearchString" v-debounce="1000" :placeholder="$t('persons.search')">
        <div v-if="isPersonsLoading" class="spincontainer">
          <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> loading...
        </div>

        <persons-list v-if="persons != null" 
            :persons="persons" 
            :listType="'SelectOne'"
            :optionSelectAll="false"
            v-on:personListChanged="personListChanged"></persons-list>

        <div v-if="errorMessage" class="w3-panel errorBox w3-round">
          {{ errorMessage }} 
          <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/>
        </div>

        <div class="buttonContainer">
          <div class="flex"> 
            <button :class="{'button-inactive': !onePersonSelected, 'button-default': onePersonSelected }" @click="selectPerson()">{{ $t('tournament.selectManager.select') }}</button>
          </div>  
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import PersonsList from "@/components/players/PersonsList";
import Multiselect from '@vueform/multiselect';

const apiName = 'api';
const myInit = { 
  response: false, 
};


export default {
  name: 'SelectUser',
  components: {Multiselect, PersonsList},
  data: function () {
    return {
      awaitingPersonSearch: false,
      clubs: [],
      errorMessage: "",
      persons: [],    // Used for search
      personsLoading: false,
      personSearchString: "",
      personsToBeAdded: [], // Person ID's as selected in de PersonList
      selectedClub: "",
      selectedPersonId: -1
    }
  },
  emits: [ 'cancel', 'ok' ],
  computed: {
    isPersonsLoading() {
      return this.personsLoading;
    },
    onePersonSelected() {
      return (this.personsToBeAdded.length == 1);
    }
  },
  updated: function () {
    this.$nextTick(function () {
      this.loading=false;
    })
  },
  watch: {
    personSearchString: function () {
      this.loadPersons();
    },
    selectedClub: function(oldVal, newVal) {
      if (oldVal != newVal) {
        this.loadPersons();
      }
    }
  },
  methods: {    
    loadClubs: function(query) {
      if (query != "") {
        let that = this
        let fullPath = "/club/?name=" + query;
        RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            that.clubs = response;
            return JSON.stringify(that.clubs);
          })
          .catch(error => {
            console.log(error.response);
          });
      }
    },

    loadPersons() {
      let that = this
      if (this.personSearchString != "" || this.selectedClub != null) {
        this.personsLoading = true;
        let fullPath = "/person";
        if (this.selectedClub != "" && this.selectedClub != null) {
          console.log(this.selectedClub);
          if (this.personSearchString != "" )
            fullPath = fullPath + "?clubId=" + this.selectedClub + "&name=" + encodeURIComponent(this.personSearchString);
          else
            fullPath = fullPath + "?clubId=" + this.selectedClub;
        } else
          fullPath = fullPath + "?name=" + encodeURIComponent(this.personSearchString);
        console.log("fullpath: " + fullPath)
        RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            that.persons = response
            that.personsLoading = false;
          })
          .catch(error => {
            console.log(error.response);
          });
      } else {
        this.persons = null;
      }
    },

    personListChanged: function(newVal) {
      console.log("Selected person: " + newVal);
      //store the personID's selected in the PersonList.
      //After an OK, we will save according to this list
      //In this case, the array can only contain one element.
      this.personsToBeAdded = newVal;
    },

    selectPerson: function() {
      if (this.personsToBeAdded.length == 1) {
        var selectedPerson = this.persons.filter((item) => {
          return (item.personId == this.personsToBeAdded[0]);
        })

        console.log("Setting new Manager to: " + JSON.stringify(selectedPerson[0].personId));
        this.$emit("ok", selectedPerson[0]);
      }
    }
  }
}

</script>


<style scoped>

.buttons {
  display: flex;
  flex-direction: row-reverse;
}

.fieldsContainer {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
}

.imgbtn {
    transition: border .3s linear, color .3s linear, background-color .3s linear;
}
.imgbtn:hover {
    color: #5681c2;
}

.info {
  color: #f5d997;
}

.link {
  margin-top: 1em;
}

.multiselect {
  margin-bottom: 8px;
}

/* mobile */
@media screen and (max-width: 600px) {
  .fieldsContainer {
    width: 98vw;
    max-width: 98vw;
    padding: 2vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .fieldsContainer {
    width: 80vw;
    max-width: 500px;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .fieldsContainer {
    width: 40vw;
    max-width: 600px;
  }
}


</style>
